import "@turf/turf";
import { numberFormat as Qa } from "./index.es278.js";
import "./index.es175.js";
import { getRankBy as xa } from "./index.es432.js";
import "./index.es176.js";
import { MOSAIC_POPULATION_GROUP_MAP as ja, PERSONA_LIVE_POPULATION_GROUP_MAP as za } from "./index.es452.js";
function i(u, f = "", m = "") {
  return f + Qa({ number: u, formatThousands: !0 }) + m;
}
function c(u) {
  return Math.round(u * 10) / 10;
}
function Pa(u, f) {
  let m;
  return f !== 0 ? u !== 0 ? m = (f - u) / u * 100 : m = f * 100 : m = -u * 100, m;
}
const d = (u, f, m, P) => u && Number.isFinite(u) ? i(c(u), m, P) : f, w = (u) => u === "billboard", Ja = (u) => w(u) ? "Impressions" : "Visits", Za = (u) => w(u) ? "Viewers" : "Visitors", Xa = "Visits/sq ft", Ma = "Rank", Ba = (u) => w(u) ? "Impression Freq." : "Visit Frequency", en = "Dwell Time", an = "Avg. Dwell Time", nn = "Med. Dwell Time", on = "Sales", sn = "Transactions", tn = "Sales/sq ft", F = "Avg. HHI", U = "Med. HHI", C = "Population", K = "Households", Ra = "Pop Density", Fa = "Household Size", q = "Median Age", ln = "Pop (2029)", un = "Pop (22-24)", _n = "Pop (24-29)", cn = "Bach. Deg. %", Ua = "Dom. Segment", hn = "Residents", N = "Employees", dn = "Daytime Population", Ca = "Population Density", rn = "Out-of-Market Visitors", vn = "Out-of-Market Visits", mn = "% White Collar", j = "Employee Visits", fn = "Median Salary", z = "Inbound Commuters", En = "Number of Businesses", I = {
  any_resident: " (Residents)",
  any_worker: " (Any Worker)",
  inbound_visitor: " (Visitors)",
  inbound_worker: " (Commuters)",
  resident_worker: " (Res. Employees)"
}, An = "Q001001", Ln = "Q015001", bn = "Q018001", gn = "b01001_001e", pn = "b25002_002e", Sn = "b11001_001e", T = {
  [N]: "Ext. Workforce",
  [j]: "Visits by Ext. Workforce",
  [z]: "Ext. Inbound Comm.",
  [I.any_worker]: " (Any Worker)",
  [I.inbound_worker]: " (Ext. Comm.)",
  [I.resident_worker]: " (Residents)"
}, Dn = (u, f) => {
  if (!u)
    return "";
  const m = I[u];
  return f && T[m] ? T[m] : m;
}, yn = (u, f) => {
  if (!u)
    return "";
  const m = I[u];
  return f && T[m] ? T[m] : m;
}, Vn = [
  "age_0_5",
  "age_5_15",
  "age_15_18",
  "age_18_22",
  "age_22_25",
  "age_25_30",
  "age_30_35",
  "age_35_40",
  "age_40_45",
  "age_45_50",
  "age_50_55",
  "age_55_60",
  "age_60_65",
  "age_65_70",
  "age_70_75",
  "age_75_80",
  "age_80_85",
  "age_85_plus"
], wn = [
  "hh_1",
  "hh_2",
  "hh_3",
  "hh_4",
  "hh_5",
  "hh_6",
  "hh_7+"
], x = [
  "age_under_5_years",
  "age_5_to_13_years",
  "age_14_to_17_years",
  "age_18_to_21_years",
  "age_22_to_24_years",
  "age_25_to_29_years",
  "age_30_to_34_years",
  "age_35_to_39_years",
  "age_40_to_44_years",
  "age_45_to_49_years",
  "age_50_to_54_years",
  "age_55_to_59_years",
  "age_60_to_64_years",
  "age_65_to_69_years",
  "age_70_to_74_years",
  "age_75_to_79_years",
  "age_80_to_84_years",
  "age_85_years_plus"
], Bn = ({
  calloutBoxConfig: u,
  poiInfo: f,
  isMarket: m
}) => {
  var Je, Ze, Xe, Me, ea, aa, na, oa, sa, ta, la, ia, ua, _a, ca, ha, da, ra, va, ma, fa, Ea, Aa, La, ba, ga, pa, Sa, Da, ya, Va, wa, Ta, Oa, Ha, Na, Ia;
  const {
    showMetricsVisits: P,
    showMetricsVisitsRanking: Y,
    metricsRankShowAs: Ka,
    metricsRankType: qa,
    metricsDisplayAsNA: Ya,
    showMetricsVisitors: J,
    showVisitsFrequency: Z,
    showDwellTime: X,
    showMetricsVisitsSqFt: M,
    showSales: ee,
    showTransactions: ae,
    showSalesSqFt: ne,
    showAverageTicketSize: Wa,
    showCensusMedianHouseholdIncome: oe,
    showCensusAverageHouseholdIncome: se,
    showCensusPopulation: te,
    showCensusHousehold: le,
    showCensusPopulationDensity: ie,
    showCensusMedianAge: ue,
    showCensusPersonsPerHousehold: _e,
    showPopstatsMedianHouseholdIncome: ce,
    showPopstatsAverageHouseholdIncome: he,
    showPopstatsPopulation: de,
    showPopstatsHousehold: re,
    showPopstatsPopulationDensity: ve,
    showPopstatsMedianAge: me,
    showPopstatsPopGrowth2123: fe,
    showPopstatsPopGrowth2328: Ee,
    showPopstatsPopProjection28: Ae,
    showPopstatsPersonsPerHousehold: Le,
    showPopstatsPercentCollegeDegree: be,
    showPredominantMosaicSegment: ge,
    showPredominantPersonaLiveSegment: pe,
    showResidentPopulation: Se,
    showEmployeesPopulation: De,
    showDaytimePopulation: ye,
    showMarketsCensusMedianHouseholdIncome: Ve,
    showMarketsCensusAverageHouseholdIncome: we,
    showMarketsCensusPopulation: Te,
    showMarketsCensusHousehold: Oe,
    showMarketsCensusPopulationDensity: He,
    showMarketsCensusMedianAge: Ne,
    showMarketsPopstatsMedianHouseholdIncome: Ie,
    showMarketsPopstatsAverageHouseholdIncome: Pe,
    showMarketsPopstatsPopulation: Be,
    showMarketsPopstatsHousehold: Re,
    showMarketsPopstatsPopulationDensity: Fe,
    showMarketsPopstatsMedianAge: Ue,
    showOutOfMarketVisitors: Ce,
    showOutOfMarketVisits: Ke,
    showMarketsVisitFrequency: qe,
    showMarketsAvgDwellTime: Ye,
    showMarketsMedianDwellTime: We,
    showMarketsEmployeesWorkforce: ke,
    showMarketsPercentWhiteCollar: $e,
    showMarketsVisitsByEmployees: Ge,
    showMarketsMedianSalary: Qe,
    showMarketsInboundCommuters: xe,
    showMarketsNumBusinesses: je
  } = u, {
    rankMetric: ka,
    visitMetric: g,
    visitorsMetric: p,
    visitFrequencyMetric: W,
    dwellTimeMetric: A,
    salesMetric: k,
    salesSqFtMetric: $,
    transactionsMetric: G,
    popstatsPopulationMetrics: t,
    censusPopulationMetrics: _,
    mosaicPopulationMetrics: B,
    personaLiveMetrics: R,
    visitsAudienceMetrics: O,
    marketPopulationMetrics: S,
    marketEmployeesMetrics: L,
    marketCensusMetrics: r,
    marketPopstatsMetrics: v,
    marketDemographicAudience: $a,
    marketWorkforceAudience: Ga,
    poiType: D
  } = f, ze = [
    P,
    J,
    M,
    Y,
    Z,
    X,
    ee,
    ae,
    ne,
    Wa,
    oe,
    se,
    te,
    le,
    ie,
    ue,
    _e,
    ce,
    he,
    de,
    re,
    ve,
    me,
    fe,
    Ee,
    Ae,
    Le,
    be,
    ge,
    pe,
    Se,
    De,
    ye,
    Ve,
    we,
    Te,
    Oe,
    He,
    Ne,
    Ie,
    Pe,
    Be,
    Re,
    Fe,
    Ue,
    Ce,
    Ke,
    qe,
    Ye,
    We,
    ke,
    $e,
    Ge,
    Qe,
    xe,
    je
  ].filter(Boolean), H = m && (((Je = f.category_info) == null ? void 0 : Je.sub_category) === "Business Improvement District" || ((Ze = f.category_info) == null ? void 0 : Ze.sub_category) === "Commercial District" || ((Xe = f.category_info) == null ? void 0 : Xe.sub_category) === "Downtown");
  if (!ze.length)
    return [];
  const o = [], s = Ya ? "N/A" : void 0, b = Dn(
    $a,
    H
  ), Q = yn(
    Ga,
    H
  );
  if (P) {
    const e = g.value || s, a = g.isRestricted ? `${e} *` : e;
    if (a) {
      const n = {
        label: g.label && !w(D) ? g.label : Ja(D),
        value: a
      };
      o.push(n);
    }
  }
  if (J) {
    const e = p && Number.isFinite(p.estimated_customer_count) ? i(c(p.estimated_customer_count)) : s;
    if (e) {
      const a = {
        label: Za(D),
        value: e
      };
      o.push(a);
    }
  }
  if (M && !w(D)) {
    const e = f.area_sqft, a = g.rawValue ? g.rawValue : 0, n = a && e ? i(c(a / e)) : s;
    if (n) {
      const l = { label: Xa, value: n };
      o.push(l);
    }
  }
  if (Y && !w(D) && !m) {
    const a = xa(ka, qa, Ka) || s, n = Y ? a : void 0;
    if (n) {
      const l = { label: Ma, value: n };
      o.push(l);
    }
  }
  if (Z) {
    const e = W && Number.isFinite(W) ? i(c(W)) : s;
    if (e) {
      const a = {
        label: Ba(D),
        value: e
      };
      o.push(a);
    }
  }
  if (X && !w(D)) {
    const e = A && Number.isInteger(A == null ? void 0 : A.average) ? i(Math.round(A == null ? void 0 : A.average), "", " min") : s;
    if (e) {
      const a = { label: en, value: e };
      o.push(a);
    }
  }
  if (ee) {
    const e = k == null ? void 0 : k.value, a = e && Number.isFinite(e) ? i(c(e), "$") : s;
    if (a) {
      const n = { label: on, value: a };
      o.push(n);
    }
  }
  if (ae) {
    const e = G == null ? void 0 : G.value, a = e && Number.isFinite(e) ? i(Math.round(e / 1e3) * 1e3) : s;
    if (a) {
      const n = { label: sn, value: a };
      o.push(n);
    }
  }
  if (ne && !w(D)) {
    const e = $ == null ? void 0 : $.value, a = e && Number.isFinite(e) ? i(c(e), "$") : s;
    if (a) {
      const n = { label: tn, value: a };
      o.push(n);
    }
  }
  if (oe) {
    const e = (Me = _ == null ? void 0 : _.data) == null ? void 0 : Me.hh_median_inc, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value), "$") : s;
    if (a) {
      const n = { label: U, value: a };
      o.push(n);
    }
  }
  if (se) {
    const e = (ea = _ == null ? void 0 : _.data) == null ? void 0 : ea.hh_avg_inc, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value), "$") : s;
    if (a) {
      const n = { label: F, value: a };
      o.push(n);
    }
  }
  if (te) {
    const a = Vn.map((l) => {
      var h;
      return ((h = _ == null ? void 0 : _.data) == null ? void 0 : h[l].value) || 0;
    }).reduce((l, E) => l + E, 0), n = a ? i(c(a)) : s;
    if (n) {
      const l = { label: C, value: n };
      o.push(l);
    }
  }
  if (le) {
    const a = wn.map((h) => {
      var V;
      return ((V = _ == null ? void 0 : _.data) == null ? void 0 : V[h].value) || 0;
    }).reduce((h, y) => h + y, 0), n = ((aa = _ == null ? void 0 : _.data) == null ? void 0 : aa.b25002_002e.value) || 0, l = ((na = _ == null ? void 0 : _.data) == null ? void 0 : na.b11001_001e.value) || 0, E = a || n || l ? i(c(a || n || l)) : s;
    if (E) {
      const h = { label: K, value: E };
      o.push(h);
    }
  }
  if (ie) {
    const e = (oa = _ == null ? void 0 : _.data) == null ? void 0 : oa.pop_density, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: Ra, value: a };
      o.push(n);
    }
  }
  if (ue) {
    const e = (sa = _ == null ? void 0 : _.data) == null ? void 0 : sa.median_age, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: q, value: a };
      o.push(n);
    }
  }
  if (_e) {
    const e = (ta = _ == null ? void 0 : _.data) == null ? void 0 : ta.pop_per_hh, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: Fa, value: a };
      o.push(n);
    }
  }
  if (ce) {
    const e = (la = t == null ? void 0 : t.data) == null ? void 0 : la.median_income, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value), "$") : s;
    if (a) {
      const n = { label: U, value: a };
      o.push(n);
    }
  }
  if (he) {
    const e = (ia = t == null ? void 0 : t.data) == null ? void 0 : ia.inc_per_hh, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value), "$") : s;
    if (a) {
      const n = { label: F, value: a };
      o.push(n);
    }
  }
  if (de) {
    const e = x.map((l) => {
      var h;
      return ((h = t == null ? void 0 : t.data) == null ? void 0 : h[l].value) || 0;
    }), a = e.reduce((l, E) => l + E, 0), n = e ? i(c(a)) : s;
    if (n) {
      const l = { label: C, value: n };
      o.push(l);
    }
  }
  if (re) {
    const e = (ua = t == null ? void 0 : t.data) == null ? void 0 : ua.Q015001, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: K, value: a };
      o.push(n);
    }
  }
  if (ve) {
    const e = (_a = t == null ? void 0 : t.data) == null ? void 0 : _a.pop_density, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: Ra, value: a };
      o.push(n);
    }
  }
  if (me) {
    const e = (ca = t == null ? void 0 : t.data) == null ? void 0 : ca.median_age, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: q, value: a };
      o.push(n);
    }
  }
  if (fe) {
    const a = x.map((h) => {
      var V;
      return ((V = t == null ? void 0 : t.data) == null ? void 0 : V[h].value) || 0;
    }).reduce((h, y) => h + y, 0), n = ((da = (ha = t == null ? void 0 : t.data) == null ? void 0 : ha.Q001CJ1) == null ? void 0 : da.value) || 0, l = Pa(n, a), E = l ? i(c(l), l > 0 ? "+" : "-", "%") : s;
    if (E) {
      const h = { label: un, value: E };
      o.push(h);
    }
  }
  if (Ee) {
    const a = x.map((h) => {
      var V;
      return ((V = t == null ? void 0 : t.data) == null ? void 0 : V[h].value) || 0;
    }).reduce((h, y) => h + y, 0), n = ((va = (ra = t == null ? void 0 : t.data) == null ? void 0 : ra.pop_5y_forecast) == null ? void 0 : va.value) || 0, l = Pa(a, n), E = l ? i(c(l), l > 0 ? "+" : "-", "%") : s;
    if (E) {
      const h = { label: _n, value: E };
      o.push(h);
    }
  }
  if (Ae) {
    const e = (ma = t == null ? void 0 : t.data) == null ? void 0 : ma.pop_5y_forecast, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: ln, value: a };
      o.push(n);
    }
  }
  if (Le) {
    const e = (fa = t == null ? void 0 : t.data) == null ? void 0 : fa.pop_per_hh, a = e && e.value && Number.isFinite(e.value) ? i(c(e.value)) : s;
    if (a) {
      const n = { label: Fa, value: a };
      o.push(n);
    }
  }
  if (be) {
    const e = (Ea = t == null ? void 0 : t.data) == null ? void 0 : Ea.bachelors_degree_or_higher, a = e && e.percentage && Number.isFinite(e.percentage) ? i(c(e.percentage), "", "%") : s;
    if (a) {
      const n = { label: cn, value: a };
      o.push(n);
    }
  }
  if (ge) {
    const e = B == null ? void 0 : B.predominantSegmentKey, a = B && e ? ja[e] : s;
    if (a) {
      const n = { label: Ua, value: a };
      o.push(n);
    }
  }
  if (pe) {
    const e = R == null ? void 0 : R.predominantSegmentKey, a = R && e ? za[e] : s;
    if (a) {
      const n = { label: Ua, value: a };
      o.push(n);
    }
  }
  if (Se) {
    const e = S == null ? void 0 : S.resident_pop.value, a = e && Number.isFinite(e) ? i(c(e)) : s;
    if (a) {
      const n = { label: hn, value: a };
      o.push(n);
    }
  }
  if (De) {
    const e = S == null ? void 0 : S.employees.value, a = e && Number.isFinite(e) ? i(c(e)) : s;
    if (a) {
      const n = {
        label: H ? T[N] : N,
        value: a
      };
      o.push(n);
    }
  }
  if (ye) {
    const e = S == null ? void 0 : S.daytime_pop.value, a = e && Number.isFinite(e) ? i(c(e)) : s;
    if (a) {
      const n = { label: dn, value: a };
      o.push(n);
    }
  }
  if (Ue) {
    const e = (Aa = v == null ? void 0 : v.median_age) == null ? void 0 : Aa.value, a = d(e, s);
    if (a) {
      const n = {
        label: q + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Ie) {
    const e = (La = v == null ? void 0 : v.median_income) == null ? void 0 : La.value, a = d(e, s, "$");
    if (a) {
      const n = {
        label: U + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Pe) {
    const e = (ba = v == null ? void 0 : v.inc_per_hh) == null ? void 0 : ba.value, a = d(e, s, "$");
    if (a) {
      const n = {
        label: F + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Be) {
    const e = (ga = v == null ? void 0 : v[An]) == null ? void 0 : ga.value, a = d(e, s);
    if (a) {
      const n = {
        label: C + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Re) {
    const e = ((pa = v == null ? void 0 : v[Ln]) == null ? void 0 : pa.value) || ((Sa = v == null ? void 0 : v[bn]) == null ? void 0 : Sa.value), a = d(e, s);
    if (a) {
      const n = {
        label: K + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Fe) {
    const e = (Da = v == null ? void 0 : v.pop_density) == null ? void 0 : Da.value, a = d(e, s);
    if (a) {
      const n = {
        label: Ca + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Ve) {
    const e = (ya = r == null ? void 0 : r.hh_median_inc) == null ? void 0 : ya.value, a = d(e, s, "$");
    if (a) {
      const n = {
        label: U + b,
        value: a
      };
      o.push(n);
    }
  }
  if (we) {
    const e = (Va = r == null ? void 0 : r.hh_avg_inc) == null ? void 0 : Va.value, a = d(e, s, "$");
    if (a) {
      const n = {
        label: F + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Te) {
    const e = (wa = r == null ? void 0 : r[gn]) == null ? void 0 : wa.value, a = d(e, s);
    if (a) {
      const n = {
        label: C + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Oe) {
    const e = ((Ta = r == null ? void 0 : r[pn]) == null ? void 0 : Ta.value) || ((Oa = r == null ? void 0 : r[Sn]) == null ? void 0 : Oa.value), a = d(e, s);
    if (a) {
      const n = {
        label: K + b,
        value: a
      };
      o.push(n);
    }
  }
  if (He) {
    const e = (Ha = r == null ? void 0 : r.pop_density) == null ? void 0 : Ha.value, a = d(e, s);
    if (a) {
      const n = {
        label: Ca + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Ne) {
    const e = (Na = r == null ? void 0 : r.median_age) == null ? void 0 : Na.value, a = d(e, s);
    if (a) {
      const n = {
        label: q + b,
        value: a
      };
      o.push(n);
    }
  }
  if (Ce) {
    const e = d(
      p == null ? void 0 : p.estimated_customer_count,
      s
    );
    if (e) {
      const a = {
        label: rn,
        value: e
      };
      o.push(a);
    }
  }
  if (Ke) {
    const e = g.value || s, a = g.isRestricted ? `${e} *` : e;
    if (a) {
      const n = {
        label: vn,
        value: a
      };
      o.push(n);
    }
  }
  if (qe) {
    const e = p == null ? void 0 : p.estimated_customer_count, a = g == null ? void 0 : g.rawValue, n = a && e ? a / e : void 0, l = d(n, s);
    if (l) {
      const E = {
        label: Ba(D),
        value: l
      };
      o.push(E);
    }
  }
  if (Ye) {
    const e = d(
      A == null ? void 0 : A.average,
      s,
      "",
      " min"
    );
    if (e) {
      const a = { label: an, value: e };
      o.push(a);
    }
  }
  if (We) {
    const e = d(
      A == null ? void 0 : A.median,
      s,
      "",
      " min"
    );
    if (e) {
      const a = { label: nn, value: e };
      o.push(a);
    }
  }
  if (ke) {
    const e = L == null ? void 0 : L.total_employees.value, a = d(e, s);
    if (a) {
      const n = {
        label: H ? T[N] : N,
        value: a
      };
      o.push(n);
    }
  }
  if ($e) {
    const e = L == null ? void 0 : L.white_collar_percentage.value, a = d(
      e,
      s,
      "",
      "%"
    );
    if (a) {
      const n = {
        label: mn + Q,
        value: a
      };
      o.push(n);
    }
  }
  if (Ge) {
    const e = O == null ? void 0 : O.total_ft, a = d(e, s);
    if (a) {
      const n = {
        label: (H ? T[j] : j) + Q,
        value: a
      };
      o.push(n);
    }
  }
  if (Qe) {
    const e = L == null ? void 0 : L.median_salery.value, a = d(e, s, "$");
    if (a) {
      const n = {
        label: fn + Q,
        value: a
      };
      o.push(n);
    }
  }
  if (xe) {
    const e = (Ia = O == null ? void 0 : O.breakdown) == null ? void 0 : Ia.inbound_worker, a = d(e, s, "", "%");
    if (a) {
      const l = { label: H ? T[z] : z, value: a };
      o.push(l);
    }
  }
  if (je) {
    const e = L == null ? void 0 : L.total_business.value, a = d(e, s);
    if (a) {
      const n = { label: En, value: a };
      o.push(n);
    }
  }
  return ze.length > 4 ? o.slice(0, 4) : o;
};
export {
  Bn as createMetricsLabels
};
//# sourceMappingURL=index.es397.js.map
